import {Box, Button, FormControl, IconButton, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import {FiTrash2} from "react-icons/fi";
import {useNavigate} from "react-router-dom";
import {useCallback} from "react";
import ListView from "../components/ListView/ListView";
import Window from "../components/Window/Window";
import {tokenColumns} from "../constants/dataGridColumns";
import useApiRequest from "../hooks/useApiRequest";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import useConfirmDialog from "../hooks/useConfirmDialog";
import usePaginationSearch from "../hooks/usePaginationSearch";
import LoadingContent from "../components/ui/LoadingContent";

const Tokens = () => {
  const navigate = useNavigate();
  const {data, loading, list, remove} = useApiRequest({baseUrl: "/tokens", resource: "tokens"});

  const fetcher = useCallback(
    async (query) => {
      try {
        const {success, data} = await list({...query});
        if (!success) return null;

        return {data};
      } catch (error) {
        console.error("Error al cargar los tokens:", error);
        return null;
      }
    },
    [list]
  );

  const {filters, setFilter, applyFilters, resetFilters, dataGridProps, refresh} = usePaginationSearch({
    fetcher
  });

  const handleUserClick = (e, userId) => {
    e.stopPropagation();
    if (userId) {
      navigate(`/user-form`, {state: {id: userId}});
    }
  };

  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async (id) => {
    try {
      await remove(id);
      refresh();
    } catch (error) {
      console.error("Error al eliminar el registro:", error);
    }
  });

  const handleOpenDeleteDialog = (id) => {
    const found = Array.isArray(data?.data) ? data.data.find((token) => token.id === id) : null;
    openDialog(id, found?.token || "");
  };

  const columns = [
    ...tokenColumns.filter((col) => col.field !== "email"),
    {
      field: "email",
      headerName: "Usuario",
      width: 180,
      editable: false,
      renderCell: (params) => (
        <span
          style={{
            color: "primary.main",
            textDecoration: "underline",
            cursor: "pointer"
          }}
          onClick={(e) => handleUserClick(e, params.row.user_id)}
        >
          {params.row.email}
        </span>
      )
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          aria-label="delete"
          color="error"
          onClick={(e) => {
            e.stopPropagation();
            handleOpenDeleteDialog(params.row.id);
          }}
        >
          <FiTrash2 />
        </IconButton>
      )
    }
  ];

  return (
    <Window title={"Tokens"}>
      {loading ? (
        <LoadingContent />
      ) : (
        <>
          <Box display="flex" alignItems="center" gap={2} flexWrap="wrap" marginBottom={2}>
            <FormControl margin="normal" variant="outlined" style={{width: "250px"}}>
              <InputLabel>Tipo de Token</InputLabel>
              <Select
                label="Tipo de Token"
                value={filters.type || ""}
                onChange={(e) => setFilter("type", e.target.value)}
              >
                <MenuItem value={""}>Todos</MenuItem>
                <MenuItem value={"refresh"}>Refresh</MenuItem>
                <MenuItem value={"reset"}>Reset</MenuItem>
                <MenuItem value={"register"}>Register</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Buscar cliente"
              variant="outlined"
              margin="normal"
              style={{width: "250px"}}
              value={filters.clientId || ""}
              onChange={(e) => {
                setFilter("clientId", e.target.value);
              }}
            />
            <TextField
              label="Buscar usuario"
              variant="outlined"
              margin="normal"
              style={{width: "250px"}}
              value={filters.userId || ""}
              onChange={(e) => {
                setFilter("userId", e.target.value);
              }}
            />
            <Button variant="contained" onClick={applyFilters}>
              Buscar
            </Button>
            <Button variant="contained" onClick={resetFilters}>
              Resetear
            </Button>
          </Box>
          <ListView columns={columns} getRowId={(row) => row.id} loading={loading} dataGridProps={dataGridProps} />
        </>
      )}
      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="token"
        entityLabel={itemName}
      />
    </Window>
  );
};

export default Tokens;
